import React, { Component, Fragment } from 'react';
import Label from '../../../../components/atoms/Label';
import DataTable from '../../DataTable';
import dateFormatIndo from '../../../../utils/helpers/dateFormatIndo';
import ReactDOM from 'react-dom';
import curencyFormat from '../../../../utils/helpers/curencyFormat';
import formatNumber from '../../../../utils/helpers/formatNumber';

class RiwayatNegosiasi extends Component {
  constructor(props) {
    super(props);
    this.state = {
      coloumnDataTable : [
        { data: "userTypeName",	 title: "Tipe Pengguna" },
				{ data: "userUID",	 title: "ID Pengguna" },
        { data: "loanGrade",	 title: "Peringkat" },
        { data: "loanRate",	 title: "Suku Bunga" },
				{ data: "loanAmount",	 title: "Nilai Pinjaman" },
				{ data: "loanDuration",	 title: "Tenor" },
				{ data: "taxation",	 title: "Taksasi" },
				{ data: "provisionFeePercentage",	 title: "Persentase Biaya Layanan" },
				{ data: "provisionFee",	 title: "Biaya Layanan" },
        { data: "otherFee",	 title: "Biaya Transaksi" },
        { data: "createdAt",	 title: "Waktu" },
      ],
      coloumnDefs : [
        {
          targets: [0, 1, 2],
          createdCell: (td, cellData, rowData, row, col) => { 
            ReactDOM.render( <span className={ row === 0 ? 'color-blue font-weight-bold' : ''}>{cellData || '-'}</span>, td );
          }
        }, {
          targets: 3,
					createdCell: (td, cellData, rowData, row, col) => { 
            ReactDOM.render( <span className={ row === 0 ? 'color-blue font-weight-bold' : ''}>{formatNumber(cellData, '', 2) || '-'}% p.a.</span>, td )
					}
        },{
          targets: [4, 8, 9],
					createdCell: (td, cellData, rowData, row, col) => { 
            ReactDOM.render( <span className={ row === 0 ? 'color-blue font-weight-bold' : ''}>Rp {cellData ? curencyFormat(cellData) : '-'}</span>, td )
					}
        },{
          targets: 5,
					createdCell: (td, cellData, rowData, row, col) => { 
            ReactDOM.render( <span className={ row === 0 ? 'color-blue font-weight-bold' : ''}>{cellData || '-'} hari</span>, td )
					}
        },{
          targets: [6, 7],
					createdCell: (td, cellData, rowData, row, col) => { 
            ReactDOM.render( <span className={ row === 0 ? 'color-blue font-weight-bold' : ''}>{formatNumber(cellData, '', 2) || '-'}%</span>, td )
					}
        },{
          targets: 10,
					createdCell: (td, cellData, rowData, row, col) => { 
            ReactDOM.render( <span className={ row === 0 ? 'color-blue font-weight-bold' : ''}>{cellData ? dateFormatIndo(cellData, 'long', ' ', 'hms') : '-'}</span>, td )
					}
				}
      ]
    };
  }
  componentDidMount = () =>{
  }
  render() {
    let { title, dataDetail, offeringHistory } = this.props
    let { coloumnDataTable, coloumnDefs } = this.state
    return (
      <div>
        <Label value={title} className='label-menu'/>
        <DataTable
          data = {offeringHistory} 
          coloumn = {coloumnDataTable} 
          // handleDetail = {this.handleDetail} 
          coloumnDefs = {coloumnDefs}
        />

      </div>
    );
  }
}

export default RiwayatNegosiasi;